import {$$} from '@vue-macros/reactivity-transform/macros'

import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'

export function usePeoplePropertyTypeStrategy() {

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, showAllDatabaseGroups: boolean): IFilter => {
    const value = groupItem?.value ?? null
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.Equals,
        options: {
          isCaseSensitive: true,
        },
      },
      subProperty: null,
      payload: {
        type: FilterPropertyPayloadType.Static,
        value,
      },
      isDisabled: false,
    }
  }

  return $$({
    getGroupFilter,
  })
}

